import React, { useState } from 'react';
import { useSubmissions } from '../hooks/useSubmissions';
import { GlassCard } from '../components/ui/GlassCard';
import { Check, X, ExternalLink, RefreshCw } from 'lucide-react';
export function AdminDashboardPage() {
  const {
    submissions,
    loading,
    approveSubmission,
    rejectSubmission,
    refresh
  } = useSubmissions();
  const [processingId, setProcessingId] = useState<string | null>(null);
  const handleApprove = async (submission: any) => {
    setProcessingId(submission.id);
    await approveSubmission(submission);
    setProcessingId(null);
  };
  const handleReject = async (id: string) => {
    setProcessingId(id);
    await rejectSubmission(id);
    setProcessingId(null);
  };
  return <div className="min-h-screen bg-black text-white p-8" data-id="element-358">
      <div className="max-w-7xl mx-auto" data-id="element-359">
        <div className="flex items-center justify-between mb-8" data-id="element-360">
          <h1 className="text-3xl font-bold font-special" data-id="element-361">Admin Dashboard</h1>
          <button onClick={refresh} className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors" data-id="element-362">
            <RefreshCw size={20} data-id="element-363" />
          </button>
        </div>

        <div className="grid gap-6" data-id="element-364">
          <div className="bg-white/5 rounded-xl border border-white/10 overflow-hidden" data-id="element-365">
            <div className="p-6 border-b border-white/10" data-id="element-366">
              <h2 className="text-xl font-bold" data-id="element-367">
                Pending Submissions ({submissions.length})
              </h2>
            </div>

            {loading ? <div className="p-8 text-center text-gray-400" data-id="element-368">
                Loading submissions...
              </div> : submissions.length === 0 ? <div className="p-8 text-center text-gray-400" data-id="element-369">
                No pending submissions
              </div> : <div className="divide-y divide-white/10" data-id="element-370">
                {submissions.map(submission => <div key={submission.id} className="p-6 flex flex-col md:flex-row gap-6" data-id="element-371">
                    {/* Tool Info */}
                    <div className="flex-1" data-id="element-372">
                      <div className="flex items-start gap-4 mb-4" data-id="element-373">
                        {submission.logo_url && <img src={submission.logo_url} alt={submission.name} className="w-12 h-12 rounded-lg object-cover bg-white/10" data-id="element-374" />}
                        <div data-id="element-375">
                          <h3 className="text-lg font-bold text-white" data-id="element-376">
                            {submission.name}
                          </h3>
                          <a href={submission.website_url} target="_blank" rel="noopener noreferrer" className="text-cyan-400 text-sm flex items-center gap-1 hover:underline" data-id="element-377">
                            {submission.website_url} <ExternalLink size={12} data-id="element-378" />
                          </a>
                        </div>
                      </div>

                      <p className="text-gray-300 mb-4" data-id="element-379">
                        {submission.description}
                      </p>

                      <div className="flex flex-wrap gap-2 mb-4" data-id="element-380">
                        <span className="px-2 py-1 rounded bg-white/10 text-xs text-gray-300" data-id="element-381">
                          {submission.category}
                        </span>
                        {submission.pricing_tiers?.map((tier: any, i: number) => <span key={i} className="px-2 py-1 rounded bg-white/10 text-xs text-gray-300" data-id="element-382">
                              {tier.name}: {tier.price}
                            </span>)}
                      </div>

                      <div className="text-xs text-gray-500" data-id="element-383">
                        Submitted by: {submission.submitter_email}
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex flex-row md:flex-col gap-2 justify-center" data-id="element-384">
                      <button onClick={() => handleApprove(submission)} disabled={!!processingId} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-green-500/20 text-green-400 hover:bg-green-500/30 transition-colors disabled:opacity-50" data-id="element-385">
                        <Check size={16} data-id="element-386" /> Approve
                      </button>
                      <button onClick={() => handleReject(submission.id)} disabled={!!processingId} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-red-500/20 text-red-400 hover:bg-red-500/30 transition-colors disabled:opacity-50" data-id="element-387">
                        <X size={16} data-id="element-388" /> Reject
                      </button>
                    </div>
                  </div>)}
              </div>}
          </div>
        </div>
      </div>
    </div>;
}